module.exports = __webpack_public_path__ + "st.4d75d6d2109dafe3f66e.svg";


//////////////////
// WEBPACK FOOTER
// E:/proj/news12/zb-n12/scadmin/client/src/assets/fonts/flag-icon-css/flags/4x3/st.svg
// module id = ../../../../../src/assets/fonts/flag-icon-css/flags/4x3/st.svg
// module chunks = styles